import axios from "axios";
import { Urls } from "../../../store/urls";

export const getHomePageWebinarListRepo = (id, data) => {
  let url = id
    ? Urls.GET_HOME_WEBINARS_LIST + id + "/"
    : Urls.GET_HOME_WEBINARS_LIST;
  return axios({
    method: "GET",
    url: url,
    params: data,
  });
};

export const getCmsWebinarListRepo = (id, data) => {
  let url = id
    ? Urls.GET_CMS_WEBINAR_LIST_API + id + "/"
    : Urls.GET_CMS_WEBINAR_LIST_API;
  return axios({
    method: "GET",
    url: url,
    params: data,
  });
};

export const postCmsWebinarRepo = (data, id) => {
  if (id) {
    return axios({
      method: "PUT",
      url: Urls.GET_CMS_WEBINAR_LIST_API + id + "/",
      data: data,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  return axios({
    method: "POST",
    url: Urls.GET_CMS_WEBINAR_LIST_API,
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getCmsWebinarSpeakersRepo = (id, data) => {
  return axios({
    method: "GET",
    url: Urls.GET_CMS_WEBINAR_LIST_API + id + "/webinar-speakers/",
    params: data,
  });
};

export const postCmsWebinarSpeakersRepo = (id, data) => {
  return axios({
    method: "POST",
    url: Urls.GET_CMS_WEBINAR_LIST_API + id + "/webinar-speakers/",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getCmsWebinarUrlRepo = (id, data) => {
  return axios({
    method: "GET",
    url: "/api/1/cms/webinar/" + id + "/webinar-urls/",
    params: data,
  });
};

export const postCmsWebinarUrlRepo = (id, data) => {
  return axios({
    method: "POST",
    url: "/api/1/cms/webinar/" + id + "/webinar-urls/",
    data: data,
  });
};

export const putCmsWebinarUrlRepo = (id, data) => {
  return axios({
    method: "PUT",
    url: Urls.PUT_CMS_WEBINAR_URL_API + id + "/",
    data: data,
  });
};

export const deleteCmsWebinarUrlRepo = (id) => {
  return axios({
    method: "DELETE",
    url: Urls.PUT_CMS_WEBINAR_URL_API + id + "/",
  });
};

export const getCmsWebinarSynonymRepo = (id, data) => {
  return axios({
    method: "GET",
    url: Urls.GET_CMS_WEBINAR_LIST_API + id + "/webinar-synonyms/",
    params: data,
  });
};

export const postCmsWebinarSynonymRepo = (id, data) => {
  return axios({
    method: "POST",
    url: Urls.GET_CMS_WEBINAR_LIST_API + id + "/webinar-synonyms/",
    data: data,
  });
};

export const putCmsWebinarSpeakersRepo = (id, data) => {
  return axios({
    method: "PUT",
    url: Urls.PUT_CMS_WEBINAR_SPEAKERS_API + id + "/",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteCmsWebinarSpeakersRepo = (id) => {
  return axios({
    method: "DELETE",
    url: Urls.PUT_CMS_WEBINAR_SPEAKERS_API + id + "/",
  });
};

export const getCmsSynonymsListRepo = (data) => {
  return axios({
    method: "GET",
    url: Urls.GET_CMS_SYNONYMS_LIST_API,
    params: data,
  });
};

export const getHomeWebinarsListRepo = (data) => {
  return axios({
    method: "GET",
    url: Urls.GET_HOME_WEBINARS_LIST,
    params: data,
  });
};

export const getWebinarPageDetailsRepo = (slug) => {
  return axios({
    method: "GET",
    url: Urls.GET_WEBINAR_PAGE_DETAILS + slug + "/",
  });
};

export const deleteCmsWebinarkeywordsRepo = (data) => {
  return axios({
    method: "POST",
    url: Urls.DELETE_CMS_KEYWORD_SERVICE_API,
    data: data,
  });
};

export const getSuggestedWebinarKeywordsRepo = (data) => {
  return axios({
    method: "GET",
    url: Urls.GET_WEBINAR_KEYWORDS,
    params: data,
  });
};

export const getCmsWebinarsFiltersRepo = (data) => {
  return axios({
    method: "GET",
    url: Urls.GET_WEBINAR_FILTERS_API,
    params: data,
  });
};

export const getCmsWebinarsAgendaRepo = (id) => {
  return axios({
    method: "GET",
    url: Urls.GET_CMS_WEBINAR_LIST_API + id + "/webinar-agenda",
  });
};

export const getCmsWebinarsFaqRepo = (id) => {
  return axios({
    method: "GET",
    url: Urls.GET_CMS_WEBINAR_LIST_API + id + "/faq",
  });
};

export const getCmsWebinarKeywordMappingRepo = (id) => {
  return axios({
    method: "GET",
    url: Urls.GET_CMS_WEBINAR_LIST_API + id + "/keyword-mapping",
  });
};

export const putCmsWebinarKeywordMappingRepo = (id, data) => {
  return axios({
    method: "PUT",
    url: Urls.GET_CMS_WEBINAR_LIST_API + id + "/keyword-mapping",
    data: data,
  });
};

export const putCmsWebinarAgendaRepo = (id, data) => {
  return axios({
    method: "PUT",
    url: Urls.GET_CMS_WEBINAR_LIST_API + id + "/webinar-agenda/",
    data: data,
  });
};

export const putCmsWebinarFaqRepo = (id, data) => {
  return axios({
    method: "PUT",
    url: Urls.GET_CMS_WEBINAR_LIST_API + id + "/faq",
    data: data,
  });
};